/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_HeadlineInputs */

const he_home_headline = /** @type {(inputs: Home_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`לא קונים ב-KSP בלי PriceDrop`)
};

const en_home_headline = /** @type {(inputs: Home_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Don't buy on KSP without PriceDrop`)
};

/**
* | output |
* | --- |
* | "Don't buy on KSP without PriceDrop" |
*
* @param {Home_HeadlineInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const home_headline = /** @type {((inputs?: Home_HeadlineInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_HeadlineInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_home_headline(inputs)
	return en_home_headline(inputs)
});